import { render, staticRenderFns } from "./Wp_reset_password.vue?vue&type=template&id=71b87faf&scoped=true&"
import script from "./Wp_reset_password.vue?vue&type=script&lang=js&"
export * from "./Wp_reset_password.vue?vue&type=script&lang=js&"
import style0 from "./Wp_reset_password.vue?vue&type=style&index=0&id=71b87faf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b87faf",
  null
  
)

export default component.exports